import React from 'react'
import { TaskState } from 'state/tasks'
import { TaskSections } from '../..'
import PayoutEditor from '../PayoutEditor'
import TaskScheduleEditor from '../TaskScheduleEditor'
import TaskSetUpEditor from '../TaskSetUpEditor'
import StepsEditor from './StepsEditor'
import { STEP_TYPE_ENUM } from 'services/api/constants'

interface AttendEventPurchaseTaskEditorProps {
    task: TaskState
    includedSteps: { [stepType: string]: boolean }
    toggleIncludedStep: (stepType: STEP_TYPE_ENUM, isToggled: boolean) => void
    requiredFieldNames: { [key: string]: string[] }
    selectedTaskSection: TaskSections
    showBrief?: boolean
}

const AttendEventPurchaseTaskEditor: React.FC<AttendEventPurchaseTaskEditorProps> = ({
    task,
    selectedTaskSection,
    ...props
}) => {
    switch (selectedTaskSection) {
        case TaskSections.SETUP:
            return <TaskSetUpEditor type={task.type} taskUuid={task?.uuid} />
        case TaskSections.STEPS:
            return <StepsEditor task={task} {...props} />
        case TaskSections.SCHEDULE:
            return <TaskScheduleEditor taskType={task.type} taskUuid={task?.uuid} />
        case TaskSections.PAYOUT:
            return <PayoutEditor taskType={task.type} taskUuid={task?.uuid} />
        default:
            return <></>
    }
}

export default AttendEventPurchaseTaskEditor
